import IconCircleSized from "./IconCircle"

export default IconCircleSized
